<script lang="ts">
  import { type IconProps } from '@lucide/svelte'
  import type { Component } from 'svelte'
  import Button from '../button/Button.svelte'

  type Props = {
    title?: string
    subtitle: string
    icon: Component<IconProps, Record<string, string>, ''>
    spin?: boolean
    buttonIcon?: Component<IconProps, Record<string, string>, ''>
    buttonLabel?: string
    onButtonClick?: () => void
  }

  let {
    title,
    subtitle,
    icon: Icon,
    spin = false,
    buttonIcon: ButtonIcon,
    buttonLabel,
    onButtonClick,
  }: Props = $props()
</script>

<div class="container">
  <Icon size="4rem" strokeWidth={1.75} class={spin ? 'spin' : undefined} />
  <div class="text-container">
    {#if title}
      <p class="title">{title}</p>
    {/if}
    <small class="subtitle">{subtitle}</small>
  </div>
  {#if onButtonClick && buttonLabel}
    <Button onclick={onButtonClick} size="sm">
      {#if ButtonIcon}
        <ButtonIcon />
      {/if}
      {buttonLabel}
    </Button>
  {/if}
</div>

<style lang="scss">
  .container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1.5rem;
    gap: 0.25rem;
    text-align: center;

    .text-container {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 1.25rem;

      .title {
        font-size: 1rem;
        font-weight: 600;
        line-height: 150%;
      }

      .subtitle {
        color: var(--foreground-disabled);
        font-size: 0.75rem;
        line-height: 120%;
      }
    }
  }

  :global(.spin) {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
